import { useLanguage } from '../../contexts/LanguageContext';
import { PriorityBadge, StatusBadge } from './PriorityBadge';
import { CATEGORY_CONFIG } from './CategoryGrid';
import { MapPin, Clock } from 'lucide-react';

function timeAgo(dateStr) {
  const now = new Date();
  const d = new Date(dateStr);
  const diff = Math.floor((now - d) / 60000);
  if (diff < 1) return 'adesso';
  if (diff < 60) return `${diff} min`;
  if (diff < 1440) return `${Math.floor(diff / 60)} h`;
  return `${Math.floor(diff / 1440)} g`;
}

export default function RequestCard({ request, onClick }) {
  const { t } = useLanguage();
  const catConfig = CATEGORY_CONFIG.find(c => c.id === request.categoria);
  const Icon = catConfig?.icon;
  const color = catConfig?.color || '#A0A0A0';

  return (
    <div
      onClick={onClick}
      className="border border-[#B8D4E8] bg-white p-4 hover:border-[#FF3B30]/50 hover:bg-[#D6E8F5] transition-all cursor-pointer"
      data-testid={`request-card-${request.id}`}
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 flex items-center justify-center flex-shrink-0" style={{ color }}>
          {Icon && <Icon size={22} />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <span className="text-sm font-bold text-[#0D1B2A] uppercase tracking-wide truncate">
              {t(request.categoria)}
            </span>
            <PriorityBadge priority={request.priorita} />
            <StatusBadge status={request.stato} />
          </div>
          <p className="text-xs text-[#4A6B8A] line-clamp-2 mb-2">{request.descrizione}</p>
          <div className="flex items-center gap-4 text-[10px] text-[#6B8AB5] uppercase tracking-widest">
            {request.indirizzo && (
              <span className="flex items-center gap-1">
                <MapPin size={10} />
                {request.indirizzo}
              </span>
            )}
            <span className="flex items-center gap-1">
              <Clock size={10} />
              {timeAgo(request.created_at)} {t('fa')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
